export enum MessageSeverityType {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Neutral = 'neutral',
  Progress = 'progress',
}
